import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="720"
      height="359"
      fill="none"
      viewBox="0 0 720 359"
    >
      <path
        stroke="url(#paint0_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.739 333.255c72.972-36.346 279.364-103.971 502.904-125.298"
        className="DgDIVvlh_0"
      ></path>
      <path
        stroke="url(#paint1_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M481.839 357.514c14.29-40.522 59.594-113.567 192.465-128.496"
        className="DgDIVvlh_1"
      ></path>
      <path
        stroke="url(#paint2_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M71.975 193.825V50.933c1.216-3.11.912-9.331 18.547-14.663 16.711-5.052 133.175-19.461 228.344 14.662 10.557 3.786 10.642 20.795 10.642 20.795v72.246"
        className="DgDIVvlh_2"
      ></path>
      <path
        stroke="url(#paint3_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M352.008 145.84V88.257c-.304-3.466 1.35-9.01 6.993-11.73 9.426-4.545 81.79-17.328 159.932-7.198 18.851 2.444 18.851 14.662 18.851 14.662v61.849"
        className="DgDIVvlh_3"
      ></path>
      <path
        stroke="url(#paint4_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M73.495 32.008c42.263-10.486 152.027-22.5 252.972 13.33"
        className="DgDIVvlh_4"
      ></path>
      <path
        stroke="url(#paint5_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M73.495 24.008c42.263-10.486 152.027-22.5 252.972 13.33"
        className="DgDIVvlh_5"
      ></path>
      <path
        stroke="url(#paint6_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M177.177 1.88v26.66"
        className="DgDIVvlh_6"
      ></path>
      <path
        stroke="url(#paint7_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M451.129 38.938v26.659"
        className="DgDIVvlh_7"
      ></path>
      <path
        stroke="url(#paint8_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M351.4 69.86c26.149-7.909 103.135-20.9 184.864-5.332"
        className="DgDIVvlh_8"
      ></path>
      <path
        stroke="url(#paint9_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M351.4 62.395c26.149-7.909 103.135-20.9 184.864-5.332"
        className="DgDIVvlh_9"
      ></path>
      <path
        stroke="url(#paint10_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M546.602 97.054c15.811-.978 48.77-1.493 66.284 4.265 8.513 2.799 8.513 14.129 8.513 14.129v63.449"
        className="DgDIVvlh_10"
      ></path>
      <path
        stroke="url(#paint11_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M546.602 90.123c15.507-1.066 51.385-1.333 70.844 6.132"
        className="DgDIVvlh_11"
      ></path>
      <path
        stroke="url(#paint12_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M629.304 125.918c11.569-.973 35.686-1.485 48.5 4.244 6.23 2.785 6.23 14.057 6.23 14.057v43.476"
        className="DgDIVvlh_12"
      ></path>
      <path
        stroke="url(#paint13_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M629.304 118.956c11.314-1.105 37.491-1.381 51.689 6.354"
        className="DgDIVvlh_13"
      ></path>
      <path
        stroke="url(#paint14_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M575.183 185.027c31.013 0 100.277 7.145 143.817 14.396"
        className="DgDIVvlh_14"
      ></path>
      <path
        stroke="url(#paint15_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M234.339 142.908l99.73 2.666v52.252"
        className="DgDIVvlh_15"
      ></path>
      <path
        stroke="url(#paint16_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M573.359 190.625v-42.921l-70.237-.266"
        className="DgDIVvlh_16"
      ></path>
      <path
        stroke="url(#paint17_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M494.609 194.89v-50.652h-76.621v44.254"
        className="DgDIVvlh_17"
      ></path>
      <path
        stroke="url(#paint18_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M341.67 148.504l76.926-4.266"
        className="DgDIVvlh_18"
      ></path>
      <path
        stroke="url(#paint19_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M194.205 193.293v-46.12l31.925-3.999v60.782"
        className="DgDIVvlh_19"
      ></path>
      <path
        stroke="url(#paint20_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M468.764 150.371h18.851v41.055h-18.851z"
        className="DgDIVvlh_20"
      ></path>
      <path
        stroke="url(#paint21_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M430.454 150.371h18.851v43.188h-18.851z"
        className="DgDIVvlh_21"
      ></path>
      <path
        stroke="url(#paint22_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M204.238 155.704l10.946-1.333v46.92l-10.946-3.466v-42.121z"
        className="DgDIVvlh_22"
      ></path>
      <path
        stroke="url(#paint23_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M239.508 151.973v34.123"
        className="DgDIVvlh_23"
      ></path>
      <path
        stroke="url(#paint24_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M348.359 156.236v22.394"
        className="DgDIVvlh_24"
      ></path>
      <path
        stroke="url(#paint25_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M505.251 156.236v30.392"
        className="DgDIVvlh_25"
      ></path>
      <path
        stroke="url(#paint26_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M283.9 158.904v17.595"
        className="DgDIVvlh_26"
      ></path>
      <path
        stroke="url(#paint27_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M392.751 162.104v9.597"
        className="DgDIVvlh_27"
      ></path>
      <path
        stroke="url(#paint28_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M549.642 160.5v21.86"
        className="DgDIVvlh_28"
      ></path>
      <path
        stroke="url(#paint29_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M246.805 155.705v23.993"
        className="DgDIVvlh_29"
      ></path>
      <path
        stroke="url(#paint30_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M355.656 159.438v12.263"
        className="DgDIVvlh_30"
      ></path>
      <path
        stroke="url(#paint31_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M512.548 158.369v26.659"
        className="DgDIVvlh_31"
      ></path>
      <path
        stroke="url(#paint32_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M291.198 166.898v10.131"
        className="DgDIVvlh_32"
      ></path>
      <path
        stroke="url(#paint33_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M400.048 168.5v6.931"
        className="DgDIVvlh_33"
      ></path>
      <path
        stroke="url(#paint34_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M556.94 165.297v8.531"
        className="DgDIVvlh_34"
      ></path>
      <path
        stroke="url(#paint35_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M254.103 154.104v25.592"
        className="DgDIVvlh_35"
      ></path>
      <path
        stroke="url(#paint36_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M362.954 157.836v15.462"
        className="DgDIVvlh_36"
      ></path>
      <path
        stroke="url(#paint37_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M519.845 157.305v28.791"
        className="DgDIVvlh_37"
      ></path>
      <path
        stroke="url(#paint38_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M298.495 155.705v17.062"
        className="DgDIVvlh_38"
      ></path>
      <path
        stroke="url(#paint39_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M407.345 159.438v18.128"
        className="DgDIVvlh_39"
      ></path>
      <path
        stroke="url(#paint40_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M564.237 158.369v5.332"
        className="DgDIVvlh_40"
      ></path>
      <path
        stroke="url(#paint41_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M261.4 154.104v20.26"
        className="DgDIVvlh_41"
      ></path>
      <path
        stroke="url(#paint42_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M370.251 157.836v12.263"
        className="DgDIVvlh_42"
      ></path>
      <path
        stroke="url(#paint43_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M527.143 157.305v21.86"
        className="DgDIVvlh_43"
      ></path>
      <path
        stroke="url(#paint44_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M306.4 158.904v18.662"
        className="DgDIVvlh_44"
      ></path>
      <path
        stroke="url(#paint45_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M268.697 155.705v21.86"
        className="DgDIVvlh_45"
      ></path>
      <path
        stroke="url(#paint46_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M377.549 159.438V173.3"
        className="DgDIVvlh_46"
      ></path>
      <path
        stroke="url(#paint47_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M534.44 158.369v25.06"
        className="DgDIVvlh_47"
      ></path>
      <path
        stroke="url(#paint48_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M313.698 154.104v31.99"
        className="DgDIVvlh_48"
      ></path>
      <path
        stroke="url(#paint49_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M275.995 154.104v15.995"
        className="DgDIVvlh_49"
      ></path>
      <path
        stroke="url(#paint50_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M384.846 157.836v15.462"
        className="DgDIVvlh_50"
      ></path>
      <path
        stroke="url(#paint51_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M541.737 157.305v27.725"
        className="DgDIVvlh_51"
      ></path>
      <path
        stroke="url(#paint52_linear_507_7402)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M320.994 154.104v37.322"
        className="DgDIVvlh_52"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_507_7402"
          x1="253.191"
          x2="253.191"
          y1="207.957"
          y2="333.255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_507_7402"
          x1="578.072"
          x2="578.072"
          y1="229.018"
          y2="357.514"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_507_7402"
          x1="200.741"
          x2="200.741"
          y1="28.91"
          y2="193.825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_507_7402"
          x1="444.879"
          x2="444.879"
          y1="65.522"
          y2="145.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_507_7402"
          x1="199.981"
          x2="199.981"
          y1="21.301"
          y2="45.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_507_7402"
          x1="199.981"
          x2="199.981"
          y1="13.301"
          y2="37.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_507_7402"
          x1="177.677"
          x2="177.677"
          y1="1.881"
          y2="28.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_507_7402"
          x1="451.629"
          x2="451.629"
          y1="38.938"
          y2="65.597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_507_7402"
          x1="443.832"
          x2="443.832"
          y1="57.23"
          y2="69.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_507_7402"
          x1="443.832"
          x2="443.832"
          y1="49.766"
          y2="62.395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_507_7402"
          x1="584.001"
          x2="584.001"
          y1="96.445"
          y2="178.897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_507_7402"
          x1="582.024"
          x2="582.024"
          y1="89.566"
          y2="96.255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_507_7402"
          x1="656.669"
          x2="656.669"
          y1="125.312"
          y2="187.695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_507_7402"
          x1="655.149"
          x2="655.149"
          y1="118.379"
          y2="125.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_507_7402"
          x1="647.091"
          x2="647.091"
          y1="185.027"
          y2="199.423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_507_7402"
          x1="284.204"
          x2="284.204"
          y1="142.908"
          y2="197.826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_507_7402"
          x1="538.24"
          x2="538.24"
          y1="147.438"
          y2="190.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_507_7402"
          x1="456.298"
          x2="456.298"
          y1="144.238"
          y2="194.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_507_7402"
          x1="380.133"
          x2="380.133"
          y1="144.238"
          y2="148.504"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_507_7402"
          x1="210.167"
          x2="210.167"
          y1="143.174"
          y2="203.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_507_7402"
          x1="478.19"
          x2="478.19"
          y1="150.371"
          y2="191.426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_507_7402"
          x1="439.879"
          x2="439.879"
          y1="150.371"
          y2="193.559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_507_7402"
          x1="209.711"
          x2="209.711"
          y1="154.371"
          y2="201.291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_507_7402"
          x1="239.508"
          x2="238.508"
          y1="169.034"
          y2="169.034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_507_7402"
          x1="348.359"
          x2="347.359"
          y1="167.433"
          y2="167.433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_507_7402"
          x1="505.251"
          x2="504.251"
          y1="171.432"
          y2="171.432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_507_7402"
          x1="283.9"
          x2="282.9"
          y1="167.702"
          y2="167.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_507_7402"
          x1="392.751"
          x2="391.751"
          y1="166.902"
          y2="166.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint28_linear_507_7402"
          x1="549.642"
          x2="548.642"
          y1="171.43"
          y2="171.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint29_linear_507_7402"
          x1="246.805"
          x2="245.805"
          y1="167.702"
          y2="167.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_507_7402"
          x1="355.656"
          x2="354.656"
          y1="165.569"
          y2="165.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_507_7402"
          x1="512.548"
          x2="511.548"
          y1="171.699"
          y2="171.699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint32_linear_507_7402"
          x1="291.198"
          x2="290.198"
          y1="171.964"
          y2="171.964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint33_linear_507_7402"
          x1="400.048"
          x2="399.048"
          y1="171.966"
          y2="171.966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint34_linear_507_7402"
          x1="556.94"
          x2="555.94"
          y1="169.562"
          y2="169.562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint35_linear_507_7402"
          x1="254.103"
          x2="253.103"
          y1="166.9"
          y2="166.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint36_linear_507_7402"
          x1="362.954"
          x2="361.954"
          y1="165.567"
          y2="165.567"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint37_linear_507_7402"
          x1="519.845"
          x2="518.845"
          y1="171.701"
          y2="171.701"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint38_linear_507_7402"
          x1="298.495"
          x2="297.495"
          y1="164.236"
          y2="164.236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint39_linear_507_7402"
          x1="407.345"
          x2="406.345"
          y1="168.502"
          y2="168.502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint40_linear_507_7402"
          x1="564.237"
          x2="563.237"
          y1="161.035"
          y2="161.035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint41_linear_507_7402"
          x1="261.4"
          x2="260.4"
          y1="164.234"
          y2="164.234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint42_linear_507_7402"
          x1="370.251"
          x2="369.251"
          y1="163.968"
          y2="163.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint43_linear_507_7402"
          x1="527.143"
          x2="526.143"
          y1="168.235"
          y2="168.235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint44_linear_507_7402"
          x1="306.4"
          x2="305.4"
          y1="168.235"
          y2="168.235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint45_linear_507_7402"
          x1="268.697"
          x2="267.697"
          y1="166.635"
          y2="166.635"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint46_linear_507_7402"
          x1="377.549"
          x2="376.549"
          y1="166.369"
          y2="166.369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint47_linear_507_7402"
          x1="534.44"
          x2="533.44"
          y1="170.899"
          y2="170.899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint48_linear_507_7402"
          x1="313.698"
          x2="312.698"
          y1="170.099"
          y2="170.099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint49_linear_507_7402"
          x1="275.995"
          x2="274.995"
          y1="162.101"
          y2="162.101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint50_linear_507_7402"
          x1="384.846"
          x2="383.846"
          y1="165.567"
          y2="165.567"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint51_linear_507_7402"
          x1="541.737"
          x2="540.737"
          y1="171.167"
          y2="171.167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint52_linear_507_7402"
          x1="320.994"
          x2="319.994"
          y1="172.765"
          y2="172.765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84B5E7"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
      </defs>
      <style data-made-with="vivus-instant" dangerouslySetInnerHTML={{__html: '.DgDIVvlh_0{stroke-dasharray:521 523;stroke-dashoffset:522;animation:DgDIVvlh_draw 1333ms linear 0ms forwards;}.DgDIVvlh_1{stroke-dasharray:245 247;stroke-dashoffset:246;animation:DgDIVvlh_draw 1333ms linear 12ms forwards;}.DgDIVvlh_2{stroke-dasharray:497 499;stroke-dashoffset:498;animation:DgDIVvlh_draw 1333ms linear 25ms forwards;}.DgDIVvlh_3{stroke-dasharray:321 323;stroke-dashoffset:322;animation:DgDIVvlh_draw 1333ms linear 38ms forwards;}.DgDIVvlh_4{stroke-dasharray:257 259;stroke-dashoffset:258;animation:DgDIVvlh_draw 1333ms linear 51ms forwards;}.DgDIVvlh_5{stroke-dasharray:257 259;stroke-dashoffset:258;animation:DgDIVvlh_draw 1333ms linear 64ms forwards;}.DgDIVvlh_6{stroke-dasharray:27 29;stroke-dashoffset:28;animation:DgDIVvlh_draw 1333ms linear 76ms forwards;}.DgDIVvlh_7{stroke-dasharray:27 29;stroke-dashoffset:28;animation:DgDIVvlh_draw 1333ms linear 89ms forwards;}.DgDIVvlh_8{stroke-dasharray:187 189;stroke-dashoffset:188;animation:DgDIVvlh_draw 1333ms linear 102ms forwards;}.DgDIVvlh_9{stroke-dasharray:187 189;stroke-dashoffset:188;animation:DgDIVvlh_draw 1333ms linear 115ms forwards;}.DgDIVvlh_10{stroke-dasharray:148 150;stroke-dashoffset:149;animation:DgDIVvlh_draw 1333ms linear 128ms forwards;}.DgDIVvlh_11{stroke-dasharray:72 74;stroke-dashoffset:73;animation:DgDIVvlh_draw 1333ms linear 141ms forwards;}.DgDIVvlh_12{stroke-dasharray:109 111;stroke-dashoffset:110;animation:DgDIVvlh_draw 1333ms linear 153ms forwards;}.DgDIVvlh_13{stroke-dasharray:53 55;stroke-dashoffset:54;animation:DgDIVvlh_draw 1333ms linear 166ms forwards;}.DgDIVvlh_14{stroke-dasharray:145 147;stroke-dashoffset:146;animation:DgDIVvlh_draw 1333ms linear 179ms forwards;}.DgDIVvlh_15{stroke-dasharray:153 155;stroke-dashoffset:154;animation:DgDIVvlh_draw 1333ms linear 192ms forwards;}.DgDIVvlh_16{stroke-dasharray:114 116;stroke-dashoffset:115;animation:DgDIVvlh_draw 1333ms linear 205ms forwards;}.DgDIVvlh_17{stroke-dasharray:172 174;stroke-dashoffset:173;animation:DgDIVvlh_draw 1333ms linear 217ms forwards;}.DgDIVvlh_18{stroke-dasharray:78 80;stroke-dashoffset:79;animation:DgDIVvlh_draw 1333ms linear 230ms forwards;}.DgDIVvlh_19{stroke-dasharray:140 142;stroke-dashoffset:141;animation:DgDIVvlh_draw 1333ms linear 243ms forwards;}.DgDIVvlh_20{stroke-dasharray:120 122;stroke-dashoffset:121;animation:DgDIVvlh_draw 1333ms linear 256ms forwards;}.DgDIVvlh_21{stroke-dasharray:125 127;stroke-dashoffset:126;animation:DgDIVvlh_draw 1333ms linear 269ms forwards;}.DgDIVvlh_22{stroke-dasharray:112 114;stroke-dashoffset:113;animation:DgDIVvlh_draw 1333ms linear 282ms forwards;}.DgDIVvlh_23{stroke-dasharray:35 37;stroke-dashoffset:36;animation:DgDIVvlh_draw 1333ms linear 294ms forwards;}.DgDIVvlh_24{stroke-dasharray:23 25;stroke-dashoffset:24;animation:DgDIVvlh_draw 1333ms linear 307ms forwards;}.DgDIVvlh_25{stroke-dasharray:31 33;stroke-dashoffset:32;animation:DgDIVvlh_draw 1333ms linear 320ms forwards;}.DgDIVvlh_26{stroke-dasharray:18 20;stroke-dashoffset:19;animation:DgDIVvlh_draw 1333ms linear 333ms forwards;}.DgDIVvlh_27{stroke-dasharray:10 12;stroke-dashoffset:11;animation:DgDIVvlh_draw 1333ms linear 346ms forwards;}.DgDIVvlh_28{stroke-dasharray:22 24;stroke-dashoffset:23;animation:DgDIVvlh_draw 1333ms linear 358ms forwards;}.DgDIVvlh_29{stroke-dasharray:24 26;stroke-dashoffset:25;animation:DgDIVvlh_draw 1333ms linear 371ms forwards;}.DgDIVvlh_30{stroke-dasharray:13 15;stroke-dashoffset:14;animation:DgDIVvlh_draw 1333ms linear 384ms forwards;}.DgDIVvlh_31{stroke-dasharray:27 29;stroke-dashoffset:28;animation:DgDIVvlh_draw 1333ms linear 397ms forwards;}.DgDIVvlh_32{stroke-dasharray:11 13;stroke-dashoffset:12;animation:DgDIVvlh_draw 1333ms linear 410ms forwards;}.DgDIVvlh_33{stroke-dasharray:7 9;stroke-dashoffset:8;animation:DgDIVvlh_draw 1333ms linear 423ms forwards;}.DgDIVvlh_34{stroke-dasharray:9 11;stroke-dashoffset:10;animation:DgDIVvlh_draw 1333ms linear 435ms forwards;}.DgDIVvlh_35{stroke-dasharray:26 28;stroke-dashoffset:27;animation:DgDIVvlh_draw 1333ms linear 448ms forwards;}.DgDIVvlh_36{stroke-dasharray:16 18;stroke-dashoffset:17;animation:DgDIVvlh_draw 1333ms linear 461ms forwards;}.DgDIVvlh_37{stroke-dasharray:29 31;stroke-dashoffset:30;animation:DgDIVvlh_draw 1333ms linear 474ms forwards;}.DgDIVvlh_38{stroke-dasharray:18 20;stroke-dashoffset:19;animation:DgDIVvlh_draw 1333ms linear 487ms forwards;}.DgDIVvlh_39{stroke-dasharray:19 21;stroke-dashoffset:20;animation:DgDIVvlh_draw 1333ms linear 499ms forwards;}.DgDIVvlh_40{stroke-dasharray:6 8;stroke-dashoffset:7;animation:DgDIVvlh_draw 1333ms linear 512ms forwards;}.DgDIVvlh_41{stroke-dasharray:21 23;stroke-dashoffset:22;animation:DgDIVvlh_draw 1333ms linear 525ms forwards;}.DgDIVvlh_42{stroke-dasharray:13 15;stroke-dashoffset:14;animation:DgDIVvlh_draw 1333ms linear 538ms forwards;}.DgDIVvlh_43{stroke-dasharray:22 24;stroke-dashoffset:23;animation:DgDIVvlh_draw 1333ms linear 551ms forwards;}.DgDIVvlh_44{stroke-dasharray:19 21;stroke-dashoffset:20;animation:DgDIVvlh_draw 1333ms linear 564ms forwards;}.DgDIVvlh_45{stroke-dasharray:22 24;stroke-dashoffset:23;animation:DgDIVvlh_draw 1333ms linear 576ms forwards;}.DgDIVvlh_46{stroke-dasharray:14 16;stroke-dashoffset:15;animation:DgDIVvlh_draw 1333ms linear 589ms forwards;}.DgDIVvlh_47{stroke-dasharray:26 28;stroke-dashoffset:27;animation:DgDIVvlh_draw 1333ms linear 602ms forwards;}.DgDIVvlh_48{stroke-dasharray:32 34;stroke-dashoffset:33;animation:DgDIVvlh_draw 1333ms linear 615ms forwards;}.DgDIVvlh_49{stroke-dasharray:16 18;stroke-dashoffset:17;animation:DgDIVvlh_draw 1333ms linear 628ms forwards;}.DgDIVvlh_50{stroke-dasharray:16 18;stroke-dashoffset:17;animation:DgDIVvlh_draw 1333ms linear 641ms forwards;}.DgDIVvlh_51{stroke-dasharray:28 30;stroke-dashoffset:29;animation:DgDIVvlh_draw 1333ms linear 653ms forwards;}.DgDIVvlh_52{stroke-dasharray:38 40;stroke-dashoffset:39;animation:DgDIVvlh_draw 1333ms linear 666ms forwards;}@keyframes DgDIVvlh_draw{100%{stroke-dashoffset:0;}}@keyframes DgDIVvlh_fade{0%{stroke-opacity:1;}93.54838709677419%{stroke-opacity:1;}100%{stroke-opacity:0;}}'}}></style>
    </svg>
  );
}

export default Icon;
